import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";
import { TDataExport } from "../types";

type ExportListParams = { status?: string; company_id?: string | number; page?: number; limit?: number };
type ExportCallbacks = { onSuccess?: (res: any) => void; onError?: (err: any) => void };

export const useDataExportList = (params: ExportListParams = { limit: 50 }) => {
  return useQuery({
    queryKey: [API_ENDPOINTS.DATA_EXPORT, params],
    queryFn: () => client.get(API_ENDPOINTS.DATA_EXPORT, { params }),
    select: (res: any) => ({
      data: res.data.data as TDataExport[],
      extra: res.data.extra as { total: number; page: number; limit: number },
    }),
    refetchOnWindowFocus: false,
  });
};

export const useDataExportUpdateStatus = ({ onSuccess, onError }: ExportCallbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: { id: number; status: string; file_url?: string; expires_at?: string }) =>
      client.put(API_ENDPOINTS.DATA_EXPORT_STATUS(id), data),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.DATA_EXPORT] });
      onSuccess?.(res);
    },
    onError: (err) => onError?.(err),
  });
};
